import PropTypes from 'prop-types';
import React from 'react';
import Post from '@components/Studio/Post/Post';
import Author from '@components/Studio/Author/Author';
import NotFound from '@components/Studio/NotFound/NotFound';
import {
  getStudioSummary,
  getPageInfo,
  getStudioContent,
  getCurrentCategory,
  getCuratedCollectionsBrief,
} from '@services/studioService';
import Category from '@components/Studio/Category/Category';

const PageRouter = ({ content, ...props }) => {
  if (content && typeof content.contentType === 'undefined') {
    return (
      <Category
        pageInfo={props.pageInfo}
        summary={props.summary}
        posts={content}
        currentCategory={props.currentCategory}
        curatedButtons={props.curatedButtons}
      />
    );
  } else {
    switch (content.contentType) {
      case 0:
        return <Post post={content} {...props} />;
      case 1:
        return <Author author={content} {...props} />;
      default:
        return <NotFound />;
    }
  }
};

PageRouter.propTypes = {
  content: PropTypes.any,
  curatedButtons: PropTypes.any,
  currentCategory: PropTypes.shape({
    categoryName: PropTypes.any,
    slug: PropTypes.string,
  }),
  pageInfo: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      contentCTAs: PropTypes.array,
      heroCTA: PropTypes.any,
      heroImage: PropTypes.any,
      metaDescription: PropTypes.string,
      mobileHeroImage: PropTypes.any,
      ogImage: PropTypes.shape({
        file: PropTypes.shape({
          url: PropTypes.any,
        }),
      }),
      pageTitle: PropTypes.any,
      preFooterCTA: PropTypes.any,
      titleTag: PropTypes.string,
      webForms: PropTypes.any,
    }),
  ]),
  summary: PropTypes.shape({
    allPosts: PropTypes.any,
  }),
};

export default PageRouter;

const rcListPageKey = '3JIRJsRVAF6nj26P745vbj';

export async function getServerSideProps({ params }) {
  let dynamicPageContent, content, summary, curatedButtons;
  const currentCategory = getCurrentCategory(params.slug) || null;

  await getStudioContent(
    currentCategory?.contentfulCategorySlug || params.slug
  ).then((response) => {
    content = response;
  });

  if (!content) {
    return {
      redirect: {
        // Note: can use statusCode: number or permanent: true or false, but not both (see docs). Using permanent property gives 307 or 308 status.
        destination: '/studio/',
        statusCode: 301,
      },
    };
  } else {
    await Promise.all([
      getStudioSummary().then((response) => {
        summary = response;
      }),
      getPageInfo(currentCategory?.dpcKey || rcListPageKey).then((response) => {
        dynamicPageContent = response;
      }),
      getCuratedCollectionsBrief().then((response) => {
        curatedButtons = response;
      }),
    ]);

    return {
      props: {
        content,
        summary,
        currentCategory,
        pageInfo: dynamicPageContent,
        curatedButtons,
      },
    };
  }
}
